import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

type Props = {
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

export const HomeExpiredOther: FC<Props> = ({ onClick }) => (
  <p className="banner-customers__message">
    <FormattedMessage id="home-expired/components/Other.tsx/1" />
    <button
      type="button"
      className="banner-customers__message__link"
      onClick={onClick}
    >
      <FormattedMessage id="home-expired/components/Other.tsx/2" />
    </button>
  </p>
);
